import React from "react";
import {
    Bar,
    // ChartProps,
    // HorizontalBar,
    Line,
    ChartComponentProps,
    LinearComponentProps
} from "react-chartjs-2";
import "./ChartJsContainer.module.scss";
import { NHorizontalBar } from "./NHorizontalBar";

interface ChartJsContainerProps {
    chart: ChartComponentProps | LinearComponentProps;
    className?: string;
    title?: string;
    topContent?: JSX.Element;
    bottomContent?: JSX.Element;
}

// class Bar2 extends Bar {
//     constructor(props) {
//         super(props);
//     }

//     public draw() {
//         var xScalePaddingRight = 120;

//         // this.scale.xScalePaddingRight = xScalePaddingRight
//         // Chart.types.Bar.prototype.draw.apply(this, arguments);
//         // this.chart.ctx.fillStyle="#FFF";
//         // this.chart.ctx.fillRect(this.chart.canvas.width - xScalePaddingRight, 0, xScalePaddingRight, this.chart.canvas.height);
//     }
// }

export const ChartJsContainer = React.forwardRef<any, ChartJsContainerProps>(
    ({ chart, className, title, topContent, bottomContent }, ref) => {
        if (!chart || !chart.data || !chart.options) return null;

        const chartType = {
            bar: Bar,
            line: Line,
            horizontalBar: NHorizontalBar
        };

        return (
            <>
                <div ref={ref} className={`context-chart combo-series ${className ?? ""}`}>
                    {title != null && <h5 className="col-12 p-0 title">{title}</h5>}
                    {topContent != null && topContent}
                    <div className={"col-12 p-0 chart"}>
                        <div className="chart-area">
                            {React.createElement(chartType[chart.type ?? "bar"] ?? Bar, chart, null)}
                        </div>
                    </div>
                    {bottomContent != null && bottomContent}
                </div>
            </>
        );
    }
);

// export const ChartJsContainer = React.forwardRef((props, ref) => {
//     return <LChartJsContainer forwardedRef={ref} {...props} />;
// });
